import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import {deleto, get, patch, post, puto} from 'bukku/shared/ApiService';
import {t} from "@lingui/macro";

// Create account
export function* createRequest() {
    yield takeEvery(actions.ACCOUNT_CREATE_REQUEST, function* ({ request }, context) {
        try {
            context.allow_intercept = true;
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/accounts', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.ACCOUNT_CREATE_SUCCESS,
                account: data.account,
            });
        }
        catch (error) {
            yield put({
                type: actions.ACCOUNT_CREATE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createSuccess() {
    yield takeEvery(actions.ACCOUNT_CREATE_SUCCESS, function* () {
        yield message.success(t`Account is created.`);
    });
}
export function* createError() {
    yield takeEvery(actions.ACCOUNT_CREATE_ERROR, function* ({ error }) {
        if (!error.canSuppress)
            yield message.error(error.message);
    });
}

// Read accounts
export function* readAllRequest() {
    yield takeEvery(actions.ACCOUNT_READ_ALL_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/accounts', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.ACCOUNT_READ_ALL_SUCCESS,
                accounts: data.accounts,
                accountsPagination: data.paging,
            });
        }
        catch (error) {
            yield put({
                type: actions.ACCOUNT_READ_ALL_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readAllSuccess() {
    yield takeEvery(actions.ACCOUNT_READ_ALL_SUCCESS, () => {});
}
export function* readAllError() {
    yield takeEvery(actions.ACCOUNT_READ_ALL_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read account
export function* readRequest() {
    yield takeEvery(actions.ACCOUNT_READ_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/accounts/${id}`, null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.ACCOUNT_READ_SUCCESS,
                account: data.account,
            });
        }
        catch (error) {
            yield put({
                type: actions.ACCOUNT_READ_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readSuccess() {
    yield takeEvery(actions.ACCOUNT_READ_SUCCESS, () => {});
}
export function* readError() {
    yield takeEvery(actions.ACCOUNT_READ_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update account
export function* updateRequest() {
    yield takeEvery(actions.ACCOUNT_UPDATE_REQUEST, function* ({ id, request }, context) {
        try {
            context.allow_intercept = true;
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(puto, `/accounts/${id}`, request, context);

            // OK
            yield put({
                type: actions.ACCOUNT_UPDATE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.ACCOUNT_UPDATE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateSuccess() {
    yield takeEvery(actions.ACCOUNT_UPDATE_SUCCESS, function* () {
        yield message.success(t`Account is updated.`);
    });
}
export function* updateError() {
    yield takeEvery(actions.ACCOUNT_UPDATE_ERROR, function* ({ error }) {
        if (!error.canSuppress)
            yield message.error(error.message);
    });
}

// Archive account
export function* archiveRequest() {
    yield takeEvery(actions.ACCOUNT_ARCHIVE_REQUEST, function* ({ id, request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(patch, `/accounts/${id}`, request, context);

            yield put({
                type: actions.ACCOUNT_ARCHIVE_SUCCESS,
                request,
            });
        }
        catch (error) {
            yield put({
                type: actions.ACCOUNT_ARCHIVE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* archiveSuccess() {
    yield takeEvery(actions.ACCOUNT_ARCHIVE_SUCCESS, function* ({ request }) {
        yield message.success(request.is_archived ? t`Account is deactivated.` : t`Account is activated.`);
    });
}
export function* archiveError() {
    yield takeEvery(actions.ACCOUNT_ARCHIVE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Delete account
export function* deleteRequest() {
    yield takeEvery(actions.ACCOUNT_DELETE_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(deleto, `/accounts/${id}`, null, context);

            yield put({
                type: actions.ACCOUNT_DELETE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.ACCOUNT_DELETE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* deleteSuccess() {
    yield takeEvery(actions.ACCOUNT_DELETE_SUCCESS, function* () {
        yield message.success(t`Account is deleted.`);
    });
}
export function* deleteError() {
    yield takeEvery(actions.ACCOUNT_DELETE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Import accounts
export function* importRequest() {
    yield takeEvery(actions.ACCOUNT_IMPORT_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/accounts/batch', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.ACCOUNT_IMPORT_SUCCESS,
                data,
            });
        }
        catch (error) {
            yield put({
                type: actions.ACCOUNT_IMPORT_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* importSuccess() {
    yield takeEvery(actions.ACCOUNT_IMPORT_SUCCESS, function* ({ data }) {
        yield message.success(
            t`${data.created_count} accounts imported and ${data.updated_count} accounts updated.`,
        );
    });
}
export function* importError() {
    yield takeEvery(actions.ACCOUNT_IMPORT_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Merge Accounts
export function* mergeRequest() {
    yield takeEvery(actions.ACCOUNT_MERGE_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/accounts/merge', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.ACCOUNT_MERGE_SUCCESS,
                request,
                data,
            });
        }
        catch (error) {
            yield put({
                type: actions.ACCOUNT_MERGE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* mergeSuccess() {
    yield takeEvery(actions.ACCOUNT_MERGE_SUCCESS, function* ({ request, data }) {
        yield message.success(
            t`${request.merge_account_ids.length} accounts merged into ${data.account.name}`,
        );
    });
}
export function* mergeError() {
    yield takeEvery(actions.ACCOUNT_MERGE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(createRequest),
        fork(createSuccess),
        fork(createError),
        fork(readAllRequest),
        fork(readAllSuccess),
        fork(readAllError),
        fork(readRequest),
        fork(readSuccess),
        fork(readError),
        fork(updateRequest),
        fork(updateSuccess),
        fork(updateError),
        fork(archiveRequest),
        fork(archiveSuccess),
        fork(archiveError),
        fork(deleteRequest),
        fork(deleteSuccess),
        fork(deleteError),
        fork(importRequest),
        fork(importSuccess),
        fork(importError),
        fork(mergeRequest),
        fork(mergeSuccess),
        fork(mergeError),
    ]);
}
